import { DropdownOption } from "ui/components/Dropdown/Dropdown/types";

/** Koraci čarobnjaka, redom. Redoslijed odgovara `stepNumber` u `WizardStep`. */
export const SCHEME_STEP_LABELS: string[] = ["Osnovno", "Stavke"];

/** Naziv je obavezan, pa se dalje ide tek kad je upisan. */
export const SCHEME_MANDATORY_STEP_COUNT = 1;

export const ADJUSTMENT_OPTIONS: DropdownOption[] = [
  { value: "Percent", text: "Postotak — prati cjenik" },
  { value: "Absolute", text: "Fiksno — ne prati cjenik" },
];
